<template>
    <v-dialog :persistent="true" max-width="900px" v-model="cDialog">
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formName)
                            }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                            @click="onCancel"
                            icon
                            style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text style="padding: 0;">
                    <c-search-form
                        :displayToolbar="false"
                        :rows-per-page-items="[10, 20, 50]"
                        :fields="fields"
                        key-property="import_request_id"
                        search-url="/importRequest/search?sortField=status,importRequestId&"
                        create-url="/importRequest/save"
                        delete-url="/importRequest/delete"
                        form-type="intable"
                        ref="tableData"
                        :deleteMulti="false"
                        :acceptView="true"
                        :acceptEdit="false"
                        :acceptDelete="false"
                        @viewItem="viewItem"
                        orderBy="asc,desc"
                        :hiddenFields="hiddenFields"
                    />
                </v-card-text>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import {message} from "../../../../services";
    import axios from "axios";
    import CSearchForm from "../../../../components/form/ManageForm";
    import { requestConstants } from "@/constants";

    export default {
        name: "ImportRequestList",
        components: {message, axios, CSearchForm},
        props: {
            cDialog: {
                type: Boolean,
                default: false,
            },
            hiddenFields: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },
        data: () => {
            return {
                formName: "Danh sách thông báo giao hàng",
                inDialog: false,
                
                fields: [
                    {
                        value: "requestNumber",
                        text: "Số thông báo",
                        search: true,
                        headerStyle: "text-align:center",
                        renderItem: (item) => {
                            let text = item.requestNumber;
                            if (item.content != undefined && item.content.length > 0) {
                                text += " - " + item.content;
                            }
                            return text;
                        },
                    },
                    {
                        value: "status",
                        text: "lang.user.status",
                        search: true,
                        headerStyle: "text-align:center",
                        type: "select",
                        name: "status",
                        items: requestConstants.requestImportStatus,
                        itemText: "text",
                        itemValue: "value",
                    },
                    {
                        value: "action",
                        width: "5%",
                        text: "lang.common.actions",
                        compound: true,
                        headerStyle: "text-align:center",
                    },
                ],
            };
        },
        watch: {
            hiddenFields(value) {
                console.log(value);
            },
        },
        methods: {
            onCancel: function () {
                this.$emit("closeDialog", "");
            },
            viewItem: function (item) {
                let route = this.$router.resolve({path: '/importRequest/view/' + item.importRequestId});
                window.open(route.href, '_blank');
            },
        },
        created() {
            
        },
    };
</script>